import { createSelector } from 'reselect';
import { SERVICEINIT_PAGE_URL } from 'src/constants/constants';
import urlParamsMapper from 'src/helpers/urlParamsMapper';

const serviceInitState = state => state.serviceInit;
export const getServiceInitState = createSelector(
  [serviceInitState],
  serviceInit => serviceInit,
);

export const deriveMenuAndIndex = (pageId, isCompletePage = false) =>
  createSelector(
    [getServiceInitState],
    data => {
      const { intro, page } = data;

      let menuSource = null;
      let menuIndex = 0;

      if (page && page.menus) {
        menuSource = page;
      } else if (intro && intro.menus) {
        menuSource = intro;
      } else {
        return data.menu;
      }

      let newMenu = [];
      const { menus } = menuSource;
      let menuItemIndex = 0;
      let menuItem;
      const numOfMenus = menus.length;

      function updateNewMenu(subItem, subIndex) {
        if (subItem.subMenu.length) {
          return subItem.subMenu.forEach(updateNewMenu);
        }

        const { subMenu, ...menuData } = subItem;
        const subMenuUrl = urlParamsMapper(SERVICEINIT_PAGE_URL, {
          pageId: menuData.pageId,
        });

        if (pageId === menuData.pageId) {
          menuIndex = newMenu.length;
        }

        newMenu.push({ ...menuData, url: subMenuUrl });
      }

      for (menuItemIndex; menuItemIndex < numOfMenus; menuItemIndex += 1) {
        menuItem = menus[menuItemIndex];

        if (menuItem && menuItem.subMenu) {
          menuItem.subMenu.forEach(updateNewMenu);
        }
      }

      if (isCompletePage) {
        menuIndex++;
      }

      return { menu: newMenu, index: menuIndex };
    },
  );
